import s from './CampaignSection.module.scss';
import titleImage from "../../../assets/images/titleImage.png";
import img from "../../../assets/campains/img.png";
import img1 from "../../../assets/campains/img_1.png";
import img2 from "../../../assets/campains/img_2.png";
import img3 from "../../../assets/campains/img_3.png";
import ImageWithPlaceholder from "../../../components/Image/ImageWithPlaceholder";
import {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import api from "../../../api/client";

const CampaignSection = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [campaigns, setCampaigns] = useState([]);
    const [news, setNews] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const response = await  api.get(`/api/campaign-sections`);
                const data =  response.data;

                // adjust based on your backend response
                setCampaigns(data || []);

            } catch (error) {
                console.error(error);
            }
        };

        fetchCampaigns();
    }, []);
    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/news`);

                if (!response.ok) {
                    throw new Error('ネットワークエラー');
                }

                const data = await response.json();

                // adjust based on your backend
                setNews(data || []);

            } catch (error) {
                console.error(error);
            }
        };

        fetchNews();
    }, []);
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("ja-JP");
    };
    return (

        <div className={"row mt-5 mb-3"}>
            <div className={"col-12"}>
                <div className={s.titleWrrapper}>
                    <img className={s.titleImage} src={titleImage}/>
                    <h2 className={s.primaryTitle}>お得なキャンペーン</h2>
                    <h3 className={s.secondaryTitle}>Campaigns</h3>

                </div>
            </div>

            <div className={"col-12 col-md 12 mt-3"}>
                <div className={"row g-2"}>
                    {campaigns && campaigns.slice(0,4).map((item) => (
                        <div key={item.id} className={"col-12 col-md-6"}>
                            <div className={s.campaignCard} onClick={() => navigate(`/${item.link}`)}>

                                {/* Image */}
                                <ImageWithPlaceholder src={item.banner} className={s.banner}  />

                                 {/*Overlay Content*/}
                                <div className={s.campaignOverlay}>
                                    {/*<div className={s.campaignDate}>*/}
                                    {/*    {formatDate(item.from)}*/}
                                    {/*</div>*/}

                                    <div className={s.campaignTitle}>
                                        {item.name}
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
                <div className={"row mt-3 "}>
                    <div className={"col-12 col-md-6 mb-4"}>
                        <div className={`row `}>
                            <div className={` col-12  ${s.mainTitleContainer}`}>
                               <p className= {s.mainTitle}> 新着情報  <span >What's new</span></p>
                            </div>
                        </div>
                        {news && news.map((item) => (
                            <div key={item.id} className={"row border-bottom"} onClick={() => navigate(`/news/${item.slug}`)}>

                                <div className={`col-3 fw-bold ${s.newsDate}`}>
                                    {formatDate(item.date)}
                                </div>

                                <div className={`col-9 ${s.newsTitle}`}>
                                    {item.newsTitle}
                                </div>

                            </div>
                        ))}
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <div className={"row g-2"}>
                            {campaigns && campaigns.slice(4,8).map((item) => (
                                <div key={item.id} className={"col-12 col-md-6"}>
                                    <div className={s.campaignCard} onClick={() => navigate(`/${item.link}`)}>

                                        {/* Image */}
                                        <ImageWithPlaceholder src={item.banner} className={s.banner}  />

                                        {/*Overlay Content*/}
                                        <div className={s.campaignOverlay2nd}>
                                            {/*<div className={s.campaignDate}>*/}
                                            {/*    {formatDate(item.from)}*/}
                                            {/*</div>*/}

                                            <div className={s.campaignTitle2nd}>
                                                {item.name}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignSection;
